import React, {
  createContext,
  memo,
  useEffect,
  useLayoutEffect,
  useMemo,
  useReducer,
  useRef
} from 'react';
import cloneDeep from 'lodash/cloneDeep';
import FormView from '../view/FormView';
import { FormContext } from '../form/FormContext';
import { doesUITypeHaveSubfields } from '../../utils/formUtils';

const FormReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    default:
      return state;
  }
};

const InitalReducerState = {
  fields: [],
  mappedFields: {}
};

export const FormPreviewContext = createContext({});

const FormPreviewEngine = memo(({ form, ...props }) => {
  const [data, dispatch] = useReducer(FormReducer, InitalReducerState);
  const formRef = useRef(null);

  useEffect(() => {
    const adminFields = form.adminFields
      ? form.adminFields.map(f => Object.assign({}, f, { admin: true }))
      : [];

    const fields = [...form.fields, ...adminFields].filter(one => {
      if (
        one &&
        one.lookupInfo &&
        one.lookupInfo.subFieldInfo &&
        one.lookupInfo.subFieldInfo.parentFieldId
      ) {
        return false;
      }
      return true;
    });

    fields.sort((a, b) => {
      if (a.position < b.position) {
        return -1;
      }
      if (a.position > b.position) {
        return 1;
      }
      return 0;
    });

    //dispatch({ type: 'update', payload: { fields } });
    const allFields = cloneDeep([...form.fields, ...adminFields]);
    const mappedFields = {};
    allFields.forEach(one => {
      mappedFields[one.internalId] = one;
      if (
        doesUITypeHaveSubfields(one.uiType) &&
        one.lookupInfo &&
        one.lookupInfo.subFields
      ) {
        one.lookupInfo.subFields.forEach(oneSub => {
          let otherFormFieldId, matchingLocalFields;
          otherFormFieldId = oneSub.internalId;
          matchingLocalFields = allFields.filter(otherField => {
            if (
              otherField &&
              otherField.lookupInfo &&
              otherField.lookupInfo.subFieldInfo &&
              otherField.lookupInfo.subFieldInfo.parentFieldId ===
                one.internalId &&
              otherField.lookupInfo.subFieldInfo.externalFormFieldId ===
                otherFormFieldId
            ) {
              return true;
            }
            return false;
          });
          if (matchingLocalFields && matchingLocalFields.length) {
            oneSub.localFormFieldId = matchingLocalFields[0].internalId;
          }
        });
      }
    });

    dispatch({
      type: 'update',
      payload: {
        fields,
        mappedFields
      }
    });
  }, [form]);

  useLayoutEffect(() => {
    document.querySelectorAll('[field-id]').forEach(euf => {
      euf.style.display = 'block';
    });
  }, [data]);

  const contextProps = useMemo(
    () => ({
      formId: form ? form.id : '',
      registerField: () => {},
      getSubmissionsId: () => new Promise(r => r(null)),
      validateField: () => {},
      onFormChange: () => {}
    }),
    []
  );

  const formPreviewContextProps = useMemo(
    () => ({
      isFormPreview: true,
      mappedFields: data.mappedFields
    }),
    [data]
  );

  const viewProps = {
    form: form || {},
    isFormReadOnly: true,
    hideFormTitle: true,
    hideFormDescription: true,
    fields: data.fields,
    userInput: {},
    ...props
  };

  return (
    <FormContext.Provider value={contextProps}>
      <FormPreviewContext.Provider value={formPreviewContextProps}>
        <FormView {...viewProps} ref={formRef} />
      </FormPreviewContext.Provider>
    </FormContext.Provider>
  );
});

export default FormPreviewEngine;

// export default debounceRender(FormPreviewEngine, 50, {
//   leading: false,
//   trailing: true
// });
